import { render, staticRenderFns } from "./TailwindAvatar.vue?vue&type=template&id=9faa1ae4&"
import script from "./TailwindAvatar.vue?vue&type=script&lang=ts&"
export * from "./TailwindAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports